<template>

    <bottom-sheet ref="bottomsheet">

        <help-content></help-content>

    </bottom-sheet>

</template>

<script>
import BottomSheet from '../../components/bottomSheet/BottomSheet'
import HelpContent from '../help/HelpContent.vue'

export default {

    name: 'bottom-sheet-help',

    components: {
        BottomSheet,
        HelpContent
    },

    mounted() {
    },

    methods: {

        open() {
            this.$refs.bottomsheet.open()
        },

        close() {
            this.$refs.bottomsheet.close()
            this.$emit('close')
        }
    }

}

</script>

<style lang="scss" scoped>

.bsds {
    padding: 8px 16px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width: $above-tablet-length) {
        padding: 48px 70px;
    }

    .swim {
        width: 100%;
        margin-top: 20px;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 40px;
        }
    }

}

</style>
